/** @file The command one IK field edit becomes: ik.setKey for keyable fields while keying, else ik.set. */
import type { CommandCall, Id } from '@pose2d/format/types';
import type { EditTarget } from '../rigKit/rigView';
import { IK_KEYABLE } from './ikKeyable';

/** Every single-value IK field the Constraints panel edits (the chain goes through ik.set { bones }). */
export type IkField = (typeof IK_KEYABLE)[number] | 'uniform' | 'order' | 'target';

/** `ik.setKey { animation, target, channel, frame, value }` or `ik.set { target, value: { [field]: value } }`. */
export function ikEditCall(id: Id, field: IkField, value: number | boolean | string, target: EditTarget): CommandCall {
  const keyable = (IK_KEYABLE as readonly string[]).includes(field);
  if (keyable && target.kind === 'key') return { name: 'ik.setKey', input: { animation: target.animation, target: id, channel: field, frame: target.frame, value } };
  return { name: 'ik.set', input: { target: id, value: { [field]: value } } };
}
